import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DstAdminDeleteModalService {

  constructor(private http: HttpClient) {}

  delete(baseUrl: string, globalService: any, filterParams: any, rowData: any, modalContext: string): Observable<any> {
    const params: any = { ...globalService, ...filterParams };
    if (rowData && Object.keys(rowData).length > 0) {
      params.leid = rowData.LEID ?? rowData.leid;
      params.combination_key = rowData.COMBINATION_KEY ?? rowData.combination_key;
    }
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const url = `${baseUrl}/saveJsonObject`;
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
